// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1781 ? "e55dabe5" : chunkId) + "." + {"1208":"e7c6c6dacdb1c426","1781":"8ac2ee2c4b38af2a","4445":"7e327be0dcdd0297","9786":"3ebf8062504f4c12"}[chunkId] + ".js";
};